// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__2PSSQ","validationTips":"StatementDescriptor_validationTips__2bweI"};